"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SortDirection = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SortDirection = exports.SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["ASCEND"] = "ascend";
  SortDirection["DESCEND"] = "descend";
  SortDirection["NONE"] = "none";
  return SortDirection;
}({});
var sortColumn = function sortColumn(columnNameToSort) {
  var sortDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SortDirection.ASCEND;
  return function (firstValue, secondValue) {
    var firstItem = firstValue[columnNameToSort];
    var secondItem = secondValue[columnNameToSort];
    if (typeof firstItem === "undefined" || typeof secondItem === "undefined") {
      return 0;
    }
    if (typeof firstItem === "number" && typeof secondItem === "number") {
      return sortByNumber(firstItem, secondItem, sortDirection);
    }
    return sortByString(firstItem.toString().toLowerCase(), secondItem.toString().toLowerCase(), sortDirection);
  };
};
var sortByNumber = function sortByNumber(firstItem, secondItem, sortDirection) {
  return sortDirection === SortDirection.ASCEND ? firstItem - secondItem : secondItem - firstItem;
};
var sortByString = function sortByString(firstItem, secondItem, sortDirection) {
  if (firstItem < secondItem) {
    return sortDirection === SortDirection.ASCEND ? -1 : 1;
  }
  if (firstItem > secondItem) {
    return sortDirection === SortDirection.ASCEND ? 1 : -1;
  }
  return 0;
};
var sortTable = function sortTable(table, columnToSort, sortDirection) {
  var tempTable = _toConsumableArray(table);
  tempTable.sort(sortColumn(columnToSort, sortDirection));
  return tempTable;
};
var _default = exports.default = sortTable;